import {h, toChildArray} from "preact";


export function LivePage({children}) {
	return <div class="cl-live-page flex min-w-0 grow flex-col border-r border-r-harifzinc-950">{children}</div>
}

export function TopRowContainer({children}) {
	return <div class="cl-toprow-cont flex h-8 flex-none items-center border-b border-b-harifzinc-950 bg-harif-800 text-xs">{children}</div>
}

export function ContainerLink({children}) {
	return <div class="cl-cont-link flex grow">{children}</div>
}

export function TopPageLink({children, href, onClick, active}) {
	if (active)
		return <a class="cl-toppage-link px-4 capitalize text-amber-500" href={href} onClick={onClick}>{children}</a>
	return <a class="cl-toppage-link px-4 capitalize text-harifzinc-400" href={href} onClick={onClick}>{children}</a>
}

export function SearchBarSection({children}) {
	return <div class="cl-srch-bar-sect flex h-full w-72 justify-end">{children}</div>
}

export function SearchBarWrapper({children}) {
	return <div class="cl-srch-bar-wrap h-full w-64 flex-none p-1.5">{children}</div>
}

export function SearchBarContainer({children}) {
	return null; // <div class="cl-srch-bar-cont h-full w-full border border-harifzinc-950 bg-harifzinc-900">{children}</div>
}

export function TopRowIcon({children}) {
	return <div class="cl-toprow-icon flex h-full w-9 flex-none items-center justify-center border-l border-l-harifzinc-900">{children}</div>
}

export function SportScrollBar({children}) {
	return <div class="cl-sport-scroll-bar scrollbar-x-fancy h-20 w-full flex-none items-stretch overflow-x-auto overflow-y-hidden bg-harif-800 text-white border-t border-b border-harif-950">{children}</div>
}

export function SportsContainer({children}) {
	return <div class="cl-sports-cont flex h-full min-w-full">{children}</div>
}

export function SportButton({children, active, onClick}) {
	return <div
		class={"cl-live-sport-btn relative flex h-full w-16 shrink-0 grow-0 flex-col items-center justify-center pt-1.5 border-b-2 "+(active ? 'border-b-amber-500' : 'border-b-transparent')}
		onClick={onClick}>
		{children}
	</div>
}

export function SportIcon({children}) {
	return <div class="cl-live-sport-icon relative h-8 w-8 bg-white">{children}</div>
}

export function SportName({children}) {
	return <div class="cl-live-sport-name text-xs">{children}</div>
}

export function LiveSportContainer({children}) {
	return <div class="cl-live-sport-cont scrollbar-fancy min-h-0 grow overflow-y-scroll bg-harifzinc-900">{children}</div>
}

export function CurrentSportNameRow({children}) {
	return <div class="cl-live-sport-name-row sticky top-0 z-50 flex h-9 w-full items-center justify-between bg-emerald-600 px-2 text-sm text-white">{children}</div>
}

export function CurrentSportName({children}) {
	return <div class="cl-live-curr-sport-name px-2">{children}</div>
}

export function LiveEventsContainer({children}) {
	return <div class="cl-live-evt-cont fn-live-events">{children}</div>
}

export function TournamentNameRow({children}) {
	return <div class="cl-live-tourn-name-row flex h-7 items-center justify-start border-b border-t border-b-harifzinc-950 border-t-harifzinc-800 px-2">{children}</div>
}

export function FlagContainer({children}) {
	return <div class="cl-live-flag-cont bandiera h-4 w-6 flex items-center justify-center">{children}</div>
}

export function TournamentName({children}) {
	return <div class="cl-tourn-name px-2 text-xs">{children}</div>
}

export function FullEventRow({children}) {
	return <div class="cl-live-full-evt-row flex h-14 items-stretch border-b border-b-harifzinc-950 bg-harifzinc-800 text-white">{children}</div>
}

export function InfoSportContainer({children, onClick}) {
	return <div class="cl-live-infosport-cont w-2/5 flex-none border-r border-r-harifzinc-900 px-1 py-1.5" onClick={onClick}>{children}</div>
}

export function InfoSportContainerClickable({children, onClick}) {
	return <div class="cl-live-infosport-cont w-2/5 flex-none border-r border-r-harifzinc-900 px-1 py-1.5 cursor-pointer" onClick={onClick}>{children}</div>
}

export function InfoSportRow({children}) {
	return <div class="cl-live-infosport-row flex items-center text-xs">{children}</div>
}

export function Minutes({children}) {
	return <div class="cl-live-minutes text-xxs relative top-px border border-harifzinc-950 bg-harifzinc-900 px-1 py-px leading-none text-white">{children}</div>
}

export function Phase({children}) {
	return <div class="cl-live- grow px-1.5">{children}</div>
}

export function MarketsNumber({children}) {
	return <div class="cl-live-mkt-minutes px-1">{children}</div>
}

export function InfoTeamRow({children}) {
	return <div class="cl-live-info-team-row mt-1 flex h-6 items-center">{children}</div>
}

export function TeamName({children}) {
	return <div class="cl-live-team-name truncate">{children}</div>
}

export function TeamScoreContainer({children}) {
	return <div class="cl-live-team-score-cont flex items-center px-0.5">{children}</div>
}

export function TeamScore({children}) {
	return <div class="cl-live-team-score px-0.5 text-lg font-bold text-amber-500">{children}</div>
}

export function DashScore({children}) {
	return <div class="cl-live-dash-score ">{children}</div>
}

export function SpaceDiv({children}) {
	return <div class="cl-live-space-div grow">{children}</div>
}

export function SportItemContainer({children}) {
	return <div class="cl-live-sportitem-cont relative top-px mr-0.5 h-4 w-4 flex items-center justify-center">{children}</div>
}

export function HiddenNotifyContainer({children}) {
	return <div class="cl-live-hidd-notf-cont w-3/5 flex-none bg-harifzinc-900 text-white">{children}</div>
}

export function HiddenNotify({children}) {
	return <div class="cl-live-hidd-notf flex h-full w-full items-center justify-center text-sm text-slate-300">{children}</div>
}

export function MarketResultContainer({children}) {
	return <div class="cl-live-mtch-result-cont flex w-3/5 flex-none flex-col bg-harifzinc-900 text-white">{children}</div>
}

export function MarketResultRow({children}) {
	return <div class="cl-live-mtch-result-row relative flex h-6 w-full items-center border-b border-b-harifzinc-900 bg-harifzinc-800 text-white">{children}</div>
}

export function DropdownButton({children, onClick}) {
	return <div class="cl-live-select-btn flex h-full w-7 items-center justify-center border-r border-r-harifzinc-900" onClick={onClick}>{children}</div>
}

export function MarketResult({children, onClick}) {
	return <div class="cl-live-mtch-result px-2 pb-0.5 text-xs cursor-pointer" onClick={onClick}>{children}</div>
}

export function DropdownHiddenContainer({children, active, ref}) {
	if (active)
		return <div class="cl-live-select-hidd-container absolute top-full z-10 w-64 border-t border-t-harifzinc-950" ref={ref}>{children}</div>
	return null;// <div class="absolute top-full z-10 w-52 border-t border-t-harifzinc-950">{children}</div>
}

export function DropdownRow({children, onClick, active}) {
	if (active)
		return <div class="cl-live-select-row h-7 border border-t-0 border-harifzinc-950 bg-harifzinc-900 px-2 text-xs flex items-center text-white truncate cursor-pointer">{children}</div>
	return <div class="cl-live-select-row h-7 border border-t-0 border-harifzinc-950 bg-harifzinc-800 px-2 text-xs flex items-center text-white truncate hover:bg-harifzinc-900 cursor-pointer" onClick={onClick}>{children}</div>
}

export function OutcomeButtonContainer({children}) {
	return <div class="cl-live-out-btn-cont text-sm grid data-[num-children='3']:grid-cols-3 data-[num-children='2']:grid-cols-2" data-num-children={toChildArray(children).length}>{children}</div>
}

export function OutcomeButton({children}) {
	return <div class="cl-live-out-btn flex h-8 grow items-center justify-between border border-b-harifzinc-950 border-l-harifzinc-950 border-r-harifzinc-800 border-t-harifzinc-800 bg-harifzinc-900 px-4 first:border-l-0 overflow-x-hidden">
		<span class="truncate">Outcome</span>
		<span class="font-bold text-amber-500">3.10</span>
	</div>
}

function LivePageExample() {
	return <Fragment>
		<div class="flex h-screen border-b border-b-harifzinc-950 bg-harifzinc-900 text-white">
			<LivePage>
				<TopRowContainer>
					<ContainerLink>
						<TopPageLink>general view</TopPageLink>
						<TopPageLink>event view</TopPageLink>
						<TopPageLink>sport home</TopPageLink>
					</ContainerLink>
					<SearchBarSection>
						<SearchBarWrapper>
							<SearchBarContainer></SearchBarContainer>
						</SearchBarWrapper>
					</SearchBarSection>
					<TopRowIcon></TopRowIcon>
					<TopRowIcon></TopRowIcon>
					<TopRowIcon></TopRowIcon>
				</TopRowContainer>
				<SportScrollBar>
					<SportsContainer>
						<SportButton>
							<SportIcon>I</SportIcon>
							<SportName>Favorites</SportName>
						</SportButton>
						<SportButton>
							<SportIcon>I</SportIcon>
							<SportName>Favorites</SportName>
						</SportButton>
						<SportButton>
							<SportIcon>I</SportIcon>
							<SportName>Favorites</SportName>
						</SportButton>
					</SportsContainer>
				</SportScrollBar>
				<LiveSportContainer>
					<CurrentSportNameRow>
						<CurrentSportName>Football</CurrentSportName>
					</CurrentSportNameRow>
					<LiveEventsContainer>
						<TournamentNameRow>
							<FlagContainer></FlagContainer>
							<TournamentName>Tournament Name</TournamentName>
						</TournamentNameRow>
						<FullEventRow>
							<InfoSportContainer>
								<InfoSportRow>
									<Minutes>16</Minutes>
									<Phase>Half 1</Phase>
									<MarketsNumber>36</MarketsNumber>
								</InfoSportRow>
								<InfoTeamRow>
									<TeamName>Apollon Limassol</TeamName>
									<TeamScoreContainer>
										<TeamScore>4</TeamScore>
										<DashScore>-</DashScore>
										<TeamScore>0</TeamScore>
									</TeamScoreContainer>
									<TeamName>Apollon Limassol</TeamName>
									<SpaceDiv></SpaceDiv>
									<SportItemContainer></SportItemContainer>
								</InfoTeamRow>
							</InfoSportContainer>
							<HiddenNotifyContainer>
								<HiddenNotify>Sorry, no odds for this match</HiddenNotify>
							</HiddenNotifyContainer>
							<MarketResultContainer>
								<MarketResultRow>
									<DropdownButton>D</DropdownButton>
									<MarketResult>Match Result</MarketResult>
									<DropdownHiddenContainer>
										<DropdownRow>Match Result</DropdownRow>
										<DropdownRow>Match Result</DropdownRow>
										<DropdownRow>Match Result</DropdownRow>
										<DropdownRow>Match Result</DropdownRow>
										<DropdownRow>Match Result</DropdownRow>
									</DropdownHiddenContainer>
								</MarketResultRow>
								<OutcomeButtonContainer>
									<OutcomeButton></OutcomeButton>
									<OutcomeButton></OutcomeButton>
									<OutcomeButton></OutcomeButton>
								</OutcomeButtonContainer>
							</MarketResultContainer>
						</FullEventRow>
					</LiveEventsContainer>
				</LiveSportContainer>
			</LivePage>
			<div class="scrollbar-fancy w-72 flex-none overflow-y-scroll border-r border-r-harifzinc-950">
				MENU DESTRA
			</div>
		</div>
	</Fragment>
}
